/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Die sechzehn Farbrollen der Uebersichten, EINZELN uebersteuerbar.
 * Das gewaehlte `farbkonzept` belegt alle vor. Wer hier einen Wert setzt, uebersteuert genau diese eine Rolle -- die uebrigen folgen weiter dem Konzept. Ein leeres Feld heisst also nicht "farblos", sondern "nimm den Wert aus dem Schema".
 * SEIT DEM 29.08.2026 GEHOERT DIE AKZENTFARBE DAZU (Vorgabe des Betreibers): `accent`, `accentText` und `accentHover`. Sie ist der Gegenpol zur Hauptfarbe und traegt den Knopf "Zurueck zur Liste", Status-Marken und Zaehler. Je Konzept eigens gewaehlt und NICHT aus `primary` gerechnet -- eine gerechnete Kontrastfarbe waere im Graustufen-Konzept wieder grau.
 * WARUM EIN EIGENES OBJEKT und nicht dreizehn Felder an der Appearance: Die Rollen gehoeren zusammen und werden gemeinsam gelesen. Als Objekt laesst sich ausserdem in einem Zug feststellen, ob ueberhaupt etwas uebersteuert wurde.
 * @export
 * @interface DatabaseFarbrollen
 */
export interface DatabaseFarbrollen {
    /**
     * Aktiv- und Button-Farbe
     * @type {string}
     * @memberof DatabaseFarbrollen
     */
    primary?: string;
    /**
     * Hover fuer Buttons
     * @type {string}
     * @memberof DatabaseFarbrollen
     */
    primaryHover?: string;
    /**
     * Zerstoerende Befehle - Loeschen, Verwerfen
     * @type {string}
     * @memberof DatabaseFarbrollen
     */
    danger?: string;
    /**
     * Schrift auf der Gefahrenflaeche
     * @type {string}
     * @memberof DatabaseFarbrollen
     */
    dangerText?: string;
    /**
     * Gefahrenfarbe unter dem Zeiger
     * @type {string}
     * @memberof DatabaseFarbrollen
     */
    dangerHover?: string;
    /**
     * Gegenpol zur Hauptfarbe - Zurueck-Knopf, Status-Marken, Zaehler
     * @type {string}
     * @memberof DatabaseFarbrollen
     */
    accent?: string;
    /**
     * Schrift auf der Akzentflaeche
     * @type {string}
     * @memberof DatabaseFarbrollen
     */
    accentText?: string;
    /**
     * Akzentfarbe unter dem Zeiger
     * @type {string}
     * @memberof DatabaseFarbrollen
     */
    accentHover?: string;
    /**
     * Heller Hintergrund fuer Badges und Fokus
     * @type {string}
     * @memberof DatabaseFarbrollen
     */
    primaryLight?: string;
    /**
     * Gesamter Hintergrund der Anwendung (Canvas)
     * @type {string}
     * @memberof DatabaseFarbrollen
     */
    bgBody?: string;
    /**
     * Karten-, Modal- und Tabellen-Inselflaechen
     * @type {string}
     * @memberof DatabaseFarbrollen
     */
    bgSurface?: string;
    /**
     * Hintergrund fuer Toolbars, Header und Paginierung
     * @type {string}
     * @memberof DatabaseFarbrollen
     */
    bgToolbar?: string;
    /**
     * Rahmen fuer Trennlinien, Eingabefelder und Tabellen
     * @type {string}
     * @memberof DatabaseFarbrollen
     */
    borderColor?: string;
    /**
     * Hauptschrift und Ueberschriften
     * @type {string}
     * @memberof DatabaseFarbrollen
     */
    textMain?: string;
    /**
     * Sekundaerschrift fuer Beschriftungen und Symbole
     * @type {string}
     * @memberof DatabaseFarbrollen
     */
    textMuted?: string;
    /**
     * Dezenter Zeilen-Hover in Tabellen
     * @type {string}
     * @memberof DatabaseFarbrollen
     */
    hoverRow?: string;
}

/**
 * Check if a given object implements the DatabaseFarbrollen interface.
 */
export function instanceOfDatabaseFarbrollen(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseFarbrollenFromJSON(json: any): DatabaseFarbrollen {
    return DatabaseFarbrollenFromJSONTyped(json, false);
}

export function DatabaseFarbrollenFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseFarbrollen {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'primary': !exists(json, 'primary') ? undefined : json['primary'],
        'primaryHover': !exists(json, 'primaryHover') ? undefined : json['primaryHover'],
        'danger': !exists(json, 'danger') ? undefined : json['danger'],
        'dangerText': !exists(json, 'dangerText') ? undefined : json['dangerText'],
        'dangerHover': !exists(json, 'dangerHover') ? undefined : json['dangerHover'],
        'accent': !exists(json, 'accent') ? undefined : json['accent'],
        'accentText': !exists(json, 'accentText') ? undefined : json['accentText'],
        'accentHover': !exists(json, 'accentHover') ? undefined : json['accentHover'],
        'primaryLight': !exists(json, 'primaryLight') ? undefined : json['primaryLight'],
        'bgBody': !exists(json, 'bgBody') ? undefined : json['bgBody'],
        'bgSurface': !exists(json, 'bgSurface') ? undefined : json['bgSurface'],
        'bgToolbar': !exists(json, 'bgToolbar') ? undefined : json['bgToolbar'],
        'borderColor': !exists(json, 'borderColor') ? undefined : json['borderColor'],
        'textMain': !exists(json, 'textMain') ? undefined : json['textMain'],
        'textMuted': !exists(json, 'textMuted') ? undefined : json['textMuted'],
        'hoverRow': !exists(json, 'hoverRow') ? undefined : json['hoverRow'],
    };
}

export function DatabaseFarbrollenToJSON(value?: DatabaseFarbrollen | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'primary': value.primary,
        'primaryHover': value.primaryHover,
        'danger': value.danger,
        'dangerText': value.dangerText,
        'dangerHover': value.dangerHover,
        'accent': value.accent,
        'accentText': value.accentText,
        'accentHover': value.accentHover,
        'primaryLight': value.primaryLight,
        'bgBody': value.bgBody,
        'bgSurface': value.bgSurface,
        'bgToolbar': value.bgToolbar,
        'borderColor': value.borderColor,
        'textMain': value.textMain,
        'textMuted': value.textMuted,
        'hoverRow': value.hoverRow,
    };
}

